module.exports = __webpack_public_path__ + "img/icon_visitreport.3369a73e.svg";